import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  PredictiveSearch,
  RecentListItem
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  ButtonDirective,
  LinkDirective,
  Option,
  SelectComponent,
  SelectedData,
  Tab,
  ToggleComponent
} from '@com-delta-omnichannel/mach';
import { SelectedRange } from '@com-delta-omnichannel/mach/lib/components/organisms/date-picker/models/date-picker.interfaces';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes,
  TripTypeOptions
} from '../../../../constants/book-widget.constants';
import { BookWidgetAem } from '../../../../models/book-widget-aem.interfaces';
import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { BookWidgetFields } from '../../../../models/book-widget-fields.interfaces';
import { DatepickerConfig } from '../../../../models/common.interfaces';
import {
  SearchModalEvent,
  SearchModalEventType
} from '../../../../models/search-modal-events-object.interface';
import {
  ConnectionPickerComponent,
  MulticityRoutePickerComponent
} from '../../../common';
import { BestFareOptionsComponent } from '../../../common/best-fare-options/best-fare-options.component';
import { FlightDatePickerComponent } from '../../../common/flight-date-picker/flight-date-picker.component';
import { MeetingEventCodeComponent } from '../../../common/meeting-event-code/meeting-event-code.component';
import { MultiCityMobileAdvanceExtended } from './multi-city-mobile-advance.extended';

@Component({
  standalone: true,
  selector: 'idp-multi-city-mobile-advance',
  templateUrl: './multi-city-mobile-advance.component.html',
  styleUrls: ['./multi-city-mobile-advance.component.scss'],
  imports: [
    SelectComponent,
    ButtonDirective,
    ToggleComponent,
    CommonModule,
    MulticityRoutePickerComponent,
    ConnectionPickerComponent,
    LinkDirective,
    BestFareOptionsComponent,
    MeetingEventCodeComponent,
    FlightDatePickerComponent
  ]
})
export class MulticityMobileAdvanceComponent extends MultiCityMobileAdvanceExtended {
  @Input() bookWidgetFields!: BookWidgetFields;
  @Input() bookWidgetAem: BookWidgetAem = {} as BookWidgetAem;
  @Input() recentSearchList: RecentListItem[] = [];
  @Input() savedSearchList: string[] = [];
  @Input() searchModalTabs: Tab[] = [];
  @Input() predictiveSearchData!: PredictiveSearch;
  @Input() isFullscreen!: boolean;
  @Input() datepickerConfig: DatepickerConfig = {} as DatepickerConfig;

  @Output() addFlight: EventEmitter<void> = new EventEmitter<void>();
  @Output() removeFlight: EventEmitter<void> = new EventEmitter<void>();
  @Output() infoIconClick: EventEmitter<BookWidgetFieldInfoTypes> =
    new EventEmitter<BookWidgetFieldInfoTypes>();

  @Output() override bookWidgetFieldChange =
    new EventEmitter<BookWidgetFieldUpdateEvent>();

  @Output() swapClicked = new EventEmitter<number>();
  @Output() findFlight = new EventEmitter();
  @Output() searchModalEvent = new EventEmitter<
    SearchModalEvent<SearchModalEventType>
  >();

  @Output() searchModalTriggerClicked = new EventEmitter<SelectedData>();

  tripTypeOptions = TripTypeOptions;
  bookWidgetFieldInfoTypes = BookWidgetFieldInfoTypes;
  bookWidgetFieldUpdateTypes = BookWidgetFieldUpdateTypes;

  infoIconClickHandler(sourceIcon: BookWidgetFieldInfoTypes) {
    if (sourceIcon) this.infoIconClick.emit(sourceIcon);
  }

  onDropdownSelectionChange(
    event: Option,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: event.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onDateSelectionChange(
    selectedRange: SelectedRange,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes,
    flightIndex: number
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        selectedRange,
        flightIndex
      },
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }
}
